import { useTranslation, Trans } from 'next-i18next';
import { VideoPlayer } from '@Hotels-at-Home/hah-fe-core/dist/components';

const FragranceSection = () => {
  const { t: tFragrance } = useTranslation('', { keyPrefix: '$pages.$home.$fragranceSection' });
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  const { t: tHomeCommon } = useTranslation('', { keyPrefix: '$pages.$home.$common' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$fragrance' });

  return (
    <section className="fragrance-section hp-container clearfix">
      <div className="text-stack" data-gsap-custom-value="-30" data-gsap="fade-down">
        <p className="font-body-medium intro-text">{tFragrance('introText')}</p>
        <h2 className="font-main-heading-1">{tFragrance('title')}</h2>
        <p>{tFragrance('textBlock')}</p>
        <div className="quote">
          <h3 className="font-main-heading-4">{tFragrance('quote')}</h3>
          <span>{tFragrance('quoteAuthor')}</span>
        </div>
        <a href={tLinks('main')} className="btn-main">
          {tButton('shopNow')}
        </a>
      </div>
      <div className="images-stack">
        <VideoPlayer
          src="/videos/edt-product-page-video_javier-no-sound.mp4"
          coverTitle={tFragrance('videoTitle')}
        />
        <div className="img-bottom">
          <a href={tLinks('bath')} className="img-bot bath">
            <h3>
              <Trans
                i18nKey="categoryName"
                t={tHomeCommon}
                values={{ categoryName: tFragrance('leLabo') }}
                components={{ span: <span /> }}
              />
            </h3>
          </a>
          <a href={tLinks('candle')} className="img-bot candle">
            <h3>
              <Trans
                i18nKey="categoryName"
                t={tHomeCommon}
                values={{ categoryName: tCategory('candles') }}
                components={{ span: <span /> }}
              />
            </h3>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FragranceSection;
